import { getCurrentOrg } from './getCurrentOrg';
import {
  SipProvidersService,
  type ExternalSipProviderRequestDto,
  type ExternalSipProviderDto,
} from '../services/sip-providers';

export type { ExternalSipProviderRequestDto, ExternalSipProviderDto };

export const getSipProvidersList = async (): Promise<
  ExternalSipProviderDto[]
> => {
  return SipProvidersService.getSipProviders(getCurrentOrg());
};

export const createSipProvider = async (
  payload: ExternalSipProviderRequestDto
): Promise<ExternalSipProviderDto> => {
  return SipProvidersService.createSipProvider(getCurrentOrg(), payload);
};

export const updateSipProvider = async (
  id: string,
  payload: ExternalSipProviderRequestDto
): Promise<ExternalSipProviderDto> => {
  return SipProvidersService.updateSipProvider(getCurrentOrg(), id, payload);
};
